export const SIZE_MASTER: any = {
 womens : {

  // 👕 Western & Top Wear
  shirts: ["XS", "S", "M", "L", "XL", "XXL"],
  tshirts: ["XS", "S", "M", "L", "XL", "XXL"],
  tops: ["XS", "S", "M", "L", "XL", "XXL"],
  crop_tops: ["XS", "S", "M", "L", "XL"],
  tunics: ["S", "M", "L", "XL", "XXL"],
  dresses: ["XS", "S", "M", "L", "XL", "XXL"],
  gowns: ["S", "M", "L", "XL", "XXL"],
  jumpsuits: ["S", "M", "L", "XL", "XXL"],
  jackets: ["S", "M", "L", "XL", "XXL"],
  sweaters: ["S", "M", "L", "XL", "XXL"],
  hoodies: ["S", "M", "L", "XL", "XXL"],

  // 👖 Bottom Wear
  jeans: ["28", "30", "32", "34", "36", "38", "40", "42"],
  trousers: ["28", "30", "32", "34", "36", "38", "40", "42"],
  leggings: ["XS", "S", "M", "L", "XL", "XXL"],
  shorts: ["28", "30", "32", "34", "36", "38"],
  skirts: ["XS", "S", "M", "L", "XL", "XXL"],
  palazzos: ["S", "M", "L", "XL", "XXL"],
  trackpants: ["28", "30", "32", "34", "36", "38", "40"],

  // 👗 Ethnic Wear
  sarees: [],
  kurtas: ["S", "M", "L", "XL", "XXL", "3XL"],
  salwar_suits: ["S", "M", "L", "XL", "XXL", "3XL"],
  lehenga_choli: ["S", "M", "L", "XL", "XXL"],
  ethnic_sets: ["S", "M", "L", "XL", "XXL"],
  dupattas: ["Free Size"],

  // 🛌 Innerwear & Nightwear
  bras: ["28", "30", "32", "34", "36", "38", "40"],
  panties: ["XS", "S", "M", "L", "XL", "XXL"],
  shapewear: ["S", "M", "L", "XL", "XXL"],
  nightwear: ["S", "M", "L", "XL", "XXL", "3XL"],
  thermals: ["S", "M", "L", "XL", "XXL"],

  // 🧥 Seasonal
  winterwear: ["S", "M", "L", "XL", "XXL"],
  rainwear: ["S", "M", "L", "XL", "XXL"],

  // 👠 Footwear (India Sizes)
  heels: ["3", "4", "5", "6", "7", "8", "9"],
  flats: ["3", "4", "5", "6", "7", "8", "9"],
  sandals: ["3", "4", "5", "6", "7", "8", "9"],
  slippers: ["3", "4", "5", "6", "7", "8", "9"],
  sports_shoes: ["4", "5", "6", "7", "8", "9"],
  casual_shoes: ["4", "5", "6", "7", "8", "9"],
  boots: ["4", "5", "6", "7", "8", "9"],
  ethnic_footwear: ["3", "4", "5", "6", "7", "8", "9"],

  // 👜 Bags (No Size)
  handbags: [],
  clutches: [],
  wallets: [],
  backpacks: [],
  tote_bags: [],
  sling_bags: [],

  // 💍 Accessories
  jewellery: ["Free Size"],
  watches: ["Free Size"],
  belts: ["28", "30", "32", "34", "36"],
  scarves: ["Free Size"],
  sunglasses: ["Free Size"],
  hair_accessories: ["Free Size"],

  // 💄 Beauty & Cosmetics (No Size)
  lipsticks: [],
  foundation: [],
  compact_powder: [],
  kajal_eyeliner: [],
  mascara: [],
  nail_polish: [],
  makeup_kits: [],

  // 🧴 Personal Care (No Size)
  skincare: [],
  haircare: [],
  bath_body: [],
  fragrances: [],
  sanitary_products: [],

  // 🤰 Special
  maternity_wear: ["S", "M", "L", "XL", "XXL"],
  plus_size: ["XL", "XXL", "3XL", "4XL", "5XL"]

},
mens: {

  // 👕 Top Wear
  shirts: ["S", "M", "L", "XL", "XXL", "3XL"],
  tshirts: ["S", "M", "L", "XL", "XXL", "3XL"],
  polos: ["S", "M", "L", "XL", "XXL"],
  kurtas: ["S", "M", "L", "XL", "XXL", "3XL"],
  jackets: ["S", "M", "L", "XL", "XXL"],
  blazers: ["38", "40", "42", "44", "46"],
  sweaters: ["S", "M", "L", "XL", "XXL"],
  hoodies: ["S", "M", "L", "XL", "XXL"],
  sweatshirts: ["S", "M", "L", "XL", "XXL"],

  // 👖 Bottom Wear
  jeans: ["28", "30", "32", "34", "36", "38", "40", "42", "44"],
  trousers: ["28", "30", "32", "34", "36", "38", "40", "42", "44"],
  chinos: ["28", "30", "32", "34", "36", "38", "40", "42"],
  trackpants: ["S", "M", "L", "XL", "XXL"],
  shorts: ["28", "30", "32", "34", "36", "38", "40"],
  cargos: ["28", "30", "32", "34", "36", "38", "40", "42"],
  dhotis: ["Free Size"],
  lungis: ["Free Size"],

  // 👔 Ethnic Wear
  sherwanis: ["S", "M", "L", "XL", "XXL"],
  kurta_sets: ["S", "M", "L", "XL", "XXL", "3XL"],
  nehru_jackets: ["S", "M", "L", "XL", "XXL"],
  ethnic_jackets: ["S", "M", "L", "XL", "XXL"],

  // 🧥 Seasonal
  winterwear: ["S", "M", "L", "XL", "XXL"],
  rainwear: ["S", "M", "L", "XL", "XXL"],

  // 🛌 Innerwear & Nightwear
  innerwear: ["S", "M", "L", "XL", "XXL"],
  vests: ["S", "M", "L", "XL", "XXL"],
  boxers: ["S", "M", "L", "XL", "XXL"],
  nightwear: ["S", "M", "L", "XL", "XXL"],
  thermals: ["S", "M", "L", "XL", "XXL"],

  // 👟 Footwear (India Sizes)
  sports_shoes: ["6", "7", "8", "9", "10", "11"],
  casual_shoes: ["6", "7", "8", "9", "10", "11"],
  formal_shoes: ["6", "7", "8", "9", "10", "11"],
  sandals: ["6", "7", "8", "9", "10", "11"],
  slippers: ["6", "7", "8", "9", "10", "11"],
  loafers: ["6", "7", "8", "9", "10", "11"],
  boots: ["6", "7", "8", "9", "10", "11"],
  ethnic_footwear: ["6", "7", "8", "9", "10", "11"],

  // 👜 Bags (No Size)
  backpacks: [],
  laptop_bags: [],
  gym_bags: [],
  wallets: [],

  // ⌚ Accessories
  watches: ["Free Size"],
  belts: ["28", "30", "32", "34", "36", "38", "40"],
  sunglasses: ["Free Size"],
  caps: ["Free Size"],
  ties: ["Free Size"],
  cufflinks: ["Free Size"],
  bracelets: ["Free Size"],
  chains: ["Free Size"],

  // 💄 Grooming & Personal Care (No Size)
  skincare: [],
  haircare: [],
  beard_care: [],
  perfumes: [],
  deodorants: [],
  trimmers: [],

  // 🏋️ Activewear
  gym_wear: ["S", "M", "L", "XL", "XXL"],
  sports_tshirts: ["S", "M", "L", "XL", "XXL"],
  sports_shorts: ["S", "M", "L", "XL", "XXL"],
  compression_wear: ["S", "M", "L", "XL"],

  // 👔 Special
  plus_size: ["XL", "XXL", "3XL", "4XL", "5XL"]

},
boys: {

  // 👕 Top Wear
  tshirts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  shirts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  polos: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  sweatshirts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  hoodies: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  jackets: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  sweaters: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],

  // 👖 Bottom Wear
  jeans: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  trousers: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  trackpants: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  shorts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  cargos: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],

  // 👔 Ethnic Wear
  kurtas: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  kurta_sets: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  nehru_jackets: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],

  // 🧥 Seasonal
  winterwear: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  rainwear: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],

  // 🛌 Innerwear & Nightwear
  innerwear: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  nightwear: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  thermals: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],

  // 👟 Footwear (India Sizes)
  sports_shoes: ["1", "2", "3", "4", "5", "6"],
  casual_shoes: ["1", "2", "3", "4", "5", "6"],
  sandals: ["1", "2", "3", "4", "5", "6"],
  slippers: ["1", "2", "3", "4", "5", "6"],
  boots: ["1", "2", "3", "4", "5", "6"],

  // 🎒 Bags
  school_bags: [],
  backpacks: [],

  // ⌚ Accessories
  watches: ["Free Size"],
  caps: ["Free Size"],
  sunglasses: ["Free Size"],
  belts: ["22", "24", "26", "28"],

  // 🧴 Personal Care
  skincare: [],
  haircare: [],

  // 🏃 Activewear
  sports_tshirts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  sports_shorts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  sports_sets: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"]

},
girls: {

  // 👕 Top Wear
  tshirts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  tops: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  shirts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  sweatshirts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  hoodies: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  jackets: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  sweaters: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],

  // 👗 Dresses
  dresses: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  frocks: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  jumpsuits: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  co_ords: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],

  // 👖 Bottom Wear
  jeans: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  trousers: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  leggings: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  skirts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  shorts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  trackpants: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],

  // 👑 Ethnic Wear
  kurtis: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  kurta_sets: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  lehenga_sets: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  ethnic_sets: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],

  // 🧥 Seasonal
  winterwear: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  rainwear: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],

  // 🛌 Innerwear & Nightwear
  innerwear: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  nightwear: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  thermals: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],

  // 👟 Footwear (India Sizes)
  sports_shoes: ["1", "2", "3", "4", "5", "6"],
  casual_shoes: ["1", "2", "3", "4", "5", "6"],
  sandals: ["1", "2", "3", "4", "5", "6"],
  slippers: ["1", "2", "3", "4", "5", "6"],
  boots: ["1", "2", "3", "4", "5", "6"],

  // 🎒 Bags
  school_bags: [],
  backpacks: [],

  // 🎀 Accessories
  watches: ["Free Size"],
  hair_accessories: ["Free Size"],
  caps: ["Free Size"],
  sunglasses: ["Free Size"],
  belts: ["22", "24", "26", "28"],

  // 🧴 Personal Care
  skincare: [],
  haircare: [],

  // 🏃 Activewear
  sports_tshirts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  sports_shorts: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"],
  sports_sets: ["5Y", "6Y", "7Y", "8Y", "10Y", "12Y", "14Y"]

},
kids: {
  // 👕 Top Wear
  tshirts: ["2Y", "3Y", "4Y"],
  tops: ["2Y", "3Y", "4Y"],
  shirts: ["2Y", "3Y", "4Y"],
  sweatshirts: ["2Y", "3Y", "4Y"],
  hoodies: ["2Y", "3Y", "4Y"],
  jackets: ["2Y", "3Y", "4Y"],
  sweaters: ["2Y", "3Y", "4Y"],

  // 👗 Dresses
  dresses: ["2Y", "3Y", "4Y"],
  frocks: ["2Y", "3Y", "4Y"],

  // 👶 Sets
  jumpsuits: ["2Y", "3Y", "4Y"],
  rompers: ["2Y", "3Y", "4Y"],
  co_ords: ["2Y", "3Y", "4Y"],
  sports_sets: ["2Y", "3Y", "4Y"],

  // 👖 Bottom Wear
  jeans: ["2Y", "3Y", "4Y"],
  trousers: ["2Y", "3Y", "4Y"],
  leggings: ["2Y", "3Y", "4Y"],
  skirts: ["2Y", "3Y", "4Y"],
  shorts: ["2Y", "3Y", "4Y"],
  trackpants: ["2Y", "3Y", "4Y"],

  // 👑 Ethnic Wear
  kurtis: ["2Y", "3Y", "4Y"],
  kurtas: ["2Y", "3Y", "4Y"],
  kurta_sets: ["2Y", "3Y", "4Y"],
  lehenga_sets: ["2Y", "3Y", "4Y"],
  ethnic_sets: ["2Y", "3Y", "4Y"],

  // 🧥 Seasonal
  winterwear: ["2Y", "3Y", "4Y"],
  rainwear: ["2Y", "3Y", "4Y"],

  // 🛌 Innerwear
  innerwear: ["2Y", "3Y", "4Y"],
  nightwear: ["2Y", "3Y", "4Y"],
  thermals: ["2Y", "3Y", "4Y"],

  // 👟 Footwear
  shoes: ["6", "7", "8", "9", "10"],
  sports_shoes: ["6", "7", "8", "9", "10"],
  casual_shoes: ["6", "7", "8", "9", "10"],
  sandals: ["6", "7", "8", "9", "10"],
  slippers: ["6", "7", "8", "9", "10"],
  boots: ["6", "7", "8", "9", "10"],

  // 🎒 Bags
  backpacks: [],

  // 🎀 Accessories
  hair_accessories: ["Free Size"],
  caps: ["Free Size"],
  sunglasses: ["Free Size"],

  // 🧴 Personal Care
  skincare: [],
  haircare: []
},
baby: {

  // 👶 One-Piece & Bodysuits
  bodysuits: ["0-3M", "3-6M", "6-9M", "9-12M", "12-18M", "18-24M"],
  rompers: ["0-3M", "3-6M", "6-9M", "9-12M", "12-18M", "18-24M"],
  jumpsuits: ["0-3M", "3-6M", "6-9M", "9-12M", "12-18M", "18-24M"],
  onesies: ["0-3M", "3-6M", "6-9M", "9-12M", "12-18M", "18-24M"],

  // 👕 Top Wear
  tshirts: ["3-6M", "6-9M", "9-12M", "12-18M", "18-24M"],
  shirts: ["3-6M", "6-9M", "9-12M", "12-18M", "18-24M"],
  sweaters: ["0-3M", "3-6M", "6-9M", "9-12M", "12-18M"],
  hoodies: ["3-6M", "6-9M", "9-12M", "12-18M"],
  jackets: ["3-6M", "6-9M", "9-12M", "12-18M"],

  // 👖 Bottom Wear
  pants: ["0-3M", "3-6M", "6-9M", "9-12M", "12-18M", "18-24M"],
  leggings: ["0-3M", "3-6M", "6-9M", "9-12M", "12-18M", "18-24M"],
  shorts: ["3-6M", "6-9M", "9-12M", "12-18M", "18-24M"],
  trackpants: ["3-6M", "6-9M", "9-12M", "12-18M", "18-24M"],

  // 🛌 Sleepwear
  sleepwear: ["0-3M", "3-6M", "6-9M", "9-12M", "12-18M", "18-24M"],
  nightwear: ["0-3M", "3-6M", "6-9M", "9-12M", "12-18M", "18-24M"],

  // 🧥 Seasonal
  winterwear: ["0-3M", "3-6M", "6-9M", "9-12M", "12-18M"],
  thermals: ["3-6M", "6-9M", "9-12M", "12-18M"],

  // 👟 Footwear
  booties: ["0-6M", "6-12M", "12-18M", "18-24M"],
  baby_shoes: ["0-6M", "6-12M", "12-18M", "18-24M"],
  sandals: ["6-12M", "12-18M", "18-24M"],

  // 🧸 Accessories
  caps: ["Free Size"],
  mittens: ["Free Size"],
  socks: ["Free Size"],
  bibs: ["Free Size"],

  // 🧴 Baby Care
  skincare: [],
  haircare: [],
  baby_products: []

},


  technology: {
  // 📱 Mobiles & Tablets
  smartphones: ["64GB", "128GB", "256GB", "512GB"],
  feature_phones: ["Standard"],
  tablets: ["32GB", "64GB", "128GB", "256GB"],

  // 💻 Computers & Laptops
  laptops: ["8GB RAM / 256GB SSD", "16GB RAM / 512GB SSD", "32GB RAM / 1TB SSD"],
  desktops: ["i3", "i5", "i7", "i9"],
  monitors: ["21\"", "24\"", "27\"", "32\""],
  keyboards: ["Wired", "Wireless", "Mechanical"],
  mice: ["Wired", "Wireless", "Gaming"],
  storage: ["500GB HDD", "1TB HDD", "256GB SSD", "512GB SSD", "1TB SSD"],
  printers: ["Inkjet", "Laser", "All-in-One"],

  // ⌚ Wearables
  smartwatches: ["40mm", "44mm", "46mm"],
  fitness_bands: ["Standard"],
  vr_headsets: ["Oculus", "HTC Vive", "PS VR"],

  // 🎧 Audio & Music
  headphones: ["Wired", "Wireless", "Gaming"],
  earbuds: ["Standard"],
  speakers: ["Portable", "Smart", "Home Theater"],
  soundbars: ["2.1", "3.1", "5.1"],

  // 🔌 Tech Accessories
  powerbanks: ["5000mAh", "10000mAh", "20000mAh"],
  chargers: ["USB-A", "USB-C", "Fast Charger"],
  mobile_cases: ["iPhone", "Samsung", "OnePlus", "Xiaomi"], // can be dynamic
  screen_protectors: ["Tempered Glass", "Matte", "Privacy"],
  memory_cards: ["32GB", "64GB", "128GB", "256GB"],
  hubs_docks: ["USB 3.0", "USB-C", "Thunderbolt"],

  // 📷 Cameras & Accessories
  cameras: ["DSLR", "Mirrorless"],
  action_cameras: ["GoPro", "DJI", "Sony"],
  camera_accessories: ["Lens", "Tripod", "Flash"],

  // 🏠 Smart Home & Gadgets
  smart_home: ["Alexa", "Google Home", "Smart Plug", "Smart Bulb"],
  security_cameras: ["Indoor", "Outdoor", "Wireless", "Wired"],
  gaming_consoles: ["PS5", "Xbox", "Nintendo Switch"],
  drones: ["Mini", "Standard", "Pro"]
},
electricals: {
  // 💡 Lighting
  bulbs: ["5W", "9W", "12W", "18W"],
  tube_lights: ["20W", "40W", "60W"],
  ceiling_lights: ["12W LED", "18W LED", "24W LED"],
  chandeliers: ["3-Light", "5-Light", "7-Light"],
  emergency_lights: ["Rechargeable", "Solar", "LED Panel"],

  // 🔌 Switches & Sockets
  switches: ["1 Module", "2 Module", "3 Module", "4 Module"],
  sockets: ["5A", "10A", "16A", "Universal"],
  extension_boards: ["2 Socket", "4 Socket", "6 Socket"],

  // ⚡ Wires & Cables
  electrical_wires: ["1.0 sq mm", "1.5 sq mm", "2.5 sq mm", "4.0 sq mm"],
  cables: ["2 Core", "3 Core", "4 Core"],
  ethernet_cables: ["Cat5", "Cat6", "Cat6e"],

  // 🔋 Power & Backup
  batteries: ["AAA", "AA", "C", "D", "9V"],
  inverters: ["800VA", "1000VA", "1500VA"],
  ups: ["600VA", "1000VA", "2000VA"],
  stabilizers: ["2kVA", "3kVA", "5kVA"],

  // 🌀 Fans & Ventilation
  ceiling_fans: ["900mm", "1200mm", "1400mm"],
  table_fans: ["300mm", "400mm"],
  pedestal_fans: ["400mm", "450mm"],
  exhaust_fans: ["150mm", "200mm", "300mm"],

  // 🔥 Heating & Cooling
  room_heaters: ["Halogen", "Fan Heater", "Oil Filled"],
  geysers: ["10L", "15L", "25L"],
  coolers: ["20L", "35L", "50L", "75L"],

  // 🏠 Home Essentials
  irons: ["Dry Iron", "Steam Iron"],
  mixers: ["500W", "750W", "1000W"],
  toasters: ["2-Slice", "4-Slice"],
  kettles: ["1L", "1.5L", "2L"],

  // 🔧 Tools & Accessories
  drill_machines: ["500W", "750W", "1000W"],
  screwdrivers: ["Manual", "Electric"],
  testers: ["Basic", "Digital Multimeter"]
},
electronics: {

  // 📱 Mobile Devices
  smartphones: ["64GB", "128GB", "256GB", "512GB"],
  feature_phones: ["Basic", "Dual SIM", "4G"],
  tablets: ["32GB", "64GB", "128GB", "256GB"],

  // 🎧 Audio Devices
  earbuds: ["Bluetooth", "TWS", "Noise Cancelling"],
  headphones: ["Wired", "Bluetooth", "Over-Ear", "Gaming"],
  bluetooth_speakers: ["10W", "20W", "40W", "Portable"],
  soundbars: ["2.1 Channel", "3.1 Channel", "5.1 Channel"],

  // 🔌 Charging & Power
  chargers_cables: ["18W", "25W", "33W", "65W"],
  power_banks: ["10000mAh", "20000mAh", "30000mAh"],
  charging_cables: ["Type-C", "Micro USB", "Lightning"],
  wireless_chargers: ["10W", "15W"],

  // 💻 Computers & Accessories
  laptops: ["8GB RAM", "16GB RAM", "32GB RAM"],
  keyboards: ["Wired", "Wireless", "Mechanical"],
  mice: ["Wired", "Wireless", "Gaming"],
  webcams: ["720p", "1080p", "4K"],
  laptop_bags: ["13 inch", "15 inch", "17 inch"],

  // 📺 Entertainment
  televisions: ["32 inch", "43 inch", "50 inch", "55 inch", "65 inch"],
  tv_accessories: ["Wall Mount", "Remote", "HDMI Cable"],
  projectors: ["720p", "1080p", "4K"],

  // 📷 Cameras
  digital_cameras: ["16MP", "24MP", "48MP"],
  action_cameras: ["1080p", "4K"],
  camera_accessories: ["Tripod", "Lens", "Memory Card"],

  // 🎮 Gaming
  gaming_consoles: ["Standard", "Digital Edition"],
  gaming_controllers: ["Wired", "Wireless"],
  gaming_headsets: ["Stereo", "Surround Sound"],

  // ⌚ Wearables
  smartwatches: ["Bluetooth", "GPS", "LTE"],
  fitness_bands: ["Basic", "Heart Rate", "SpO2"],

  // 💾 Storage Devices
  memory_cards: ["16GB", "32GB", "64GB", "128GB"],
  pendrives: ["16GB", "32GB", "64GB", "128GB"],
  external_hard_drives: ["500GB", "1TB", "2TB", "4TB"]

}

};
